export default __webpack_public_path__ + "static/img_valiuablers_goods.png";